/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCLeftIcon64Regular = forwardRef('ArrowCLeftIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M42.06 54.06a1.5 1.5 0 0 1-2.12 0L23.181 37.304a7.5 7.5 0 0 1 0-10.606L39.94 9.939a1.5 1.5 0 1 1 2.122 2.122L25.303 28.818a4.5 4.5 0 0 0 0 6.364l16.758 16.757a1.5 1.5 0 0 1 0 2.122Z" })));
});
